// import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Connexion from './components/connexion/connexion';
import Inscription from './components/connexion/inscription';
// import Dashboard from './components/dashboard/dashboard';
import Admin from './components/adminstration/admin';
import Liste_utilisateur from './components/adminstration/utilisateur/liste_utilisateur';
import ListeGroupe from './components/adminstration/groupe/liste_groupe';
import ConfigurerGroupe from './components/adminstration/groupe/configurer_groupe';
import ProfilUtilisateur from './components/dashboard/mon_profil';
// import Enrolement_admin from './components/adminstration/enrolement/enrolement_admin';
// import Liste_enrolement from './components/adminstration/enrolement/liste_enrolement';
// import Enroler_vehicule from './components/adminstration/enrolement/enroler_vehicule';
// import Modifier_enrolement from './components/adminstration/enrolement/modifier_enrolement';
// import Donnees_Sygfr from './components/adminstration/enrolement/donnees_sygfr';
import Elementaires from './components/adminstration/elementaires/elementaires';
// import ListeGenresVehicules from './components/adminstration/elementaires/Genre_vehicules/liste_genres_vehicules';
import ListeTypesVehicules from './components/adminstration/elementaires/Type_vehicules/liste_types_vehicules';
// import ListeAssureurs from './components/adminstration/elementaires/Assureurs/liste_assureurs';
// import ListeFrets from './components/adminstration/elementaires/Centre_fret/liste_frets';
import ListePiecesAdmin from './components/adminstration/suivi_document/liste_pieces_admin';
import Liste_nationaux from './components/adminstration/gestion_tours/liste_nationaux';
import Liste_pays_destination from './components/adminstration/gestion_tours/liste_pays_destination';
// import Liste_bailleurs_fret from './components/adminstration/gestion_tours/liste_bailleurs_fret';
import Parametrage from './components/adminstration/Parametrage/parametrage';
import Liste_declaration_fret from './components/adminstration/fret/liste_declaration_fret';
import Journalisation from './components/adminstration/journalisation';
import Enrolement_archives from './components/adminstration/corbeille/enrolements_archives';
import Corbeilles from './components/adminstration/corbeille/corbeille';
import Liste_fret_corbeille from './components/adminstration/corbeille/fret_corbeille';
import ListeParcs from './components/adminstration/elementaires/Parc/liste_parc';
import Gestion_des_tours_national from './components/adminstration/gestion_tours/gestion_des_tours_national';
import Gestion_des_tours_international from './components/adminstration/gestion_tours/gestion_des_tours_international';
// import Modifier_vehicule_admin from './components/adminstration/enrolement/modifier_enrolementadmin';
// import ListeNatures from './components/adminstration/elementaires/Nature/liste_nature';
import Gestion_des_tours from './components/adminstration/gestion_tours/gestion_tours';
import ManuelUtilisation from './components/composant_reutilisable/manuelUtilisation';
import ManuelUtilisationAdmin from './components/composant_reutilisable/manuelUtilisationAdmin';
import ResetPassword from './components/connexion/reset_password';
import Liste_frets_ecran from './components/adminstration/fret/liste_frets_ecran';
import Rapport_et_statistique from './components/dashboard/rapport_et_statistique';
import Menu from './components/adminstration/menu';
import ListeOrganisations from './components/adminstration/elementaires/Organisation_professionnelles/liste_organisations';
// import ListeParcsTampon from './components/adminstration/elementaires/Parc_tampon/liste_parc_tampon';
import Historique_paiement from './components/adminstration/gestion_tours/historique_des_paiements';
import ListeCategorie from './components/adminstration/elementaires/categories/liste_categories';
import Liste_des_parcs from './components/adminstration/gestion_tours/listes_parcs';
import Gestion_des_tours_parc from './components/adminstration/gestion_tours/gestion_tours_parc';
import VerificationCode from './components/connexion/verification_code';
import Gie_parcs from './components/adminstration/gie/parcs_gie';
import Factures from './components/adminstration/gie/factures';
import ListeParcTampon from './components/adminstration/gestion_tours/liste_parc_tampon';
import Dashboard from './components/dashboard/dashboard';
import ListeEssieux from './components/adminstration/elementaires/Essieu/liste_essieux';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Connexion />} />
        <Route path="/Inscription" element={<Inscription />} />
        <Route path="/Verification" element={<VerificationCode />} />
        <Route path="/Admin" element={<Admin />} />
        <Route path="/Menu" element={<Menu />} />
        <Route path="/Liste-utilisateur" element={<Liste_utilisateur />} />
        <Route path="/Liste-groupe" element={<ListeGroupe />} />
        <Route path="/Configurer-groupe" element={<ConfigurerGroupe />} />
        <Route path="/Mon-profil" element={<ProfilUtilisateur />} />

        {/* <Route path="/Enrolement-admin" element={<Enrolement_admin />} />
        <Route path="/Liste-enrolement" element={<Liste_enrolement />} />
        <Route path="/Enroler-vehicule" element={<Enroler_vehicule />} />
        <Route path="/Modifier-enrolement-admin" element={<Modifier_vehicule_admin />} />
        <Route path="/Modifier-enrolement" element={<Modifier_enrolement />} /> */}

        <Route path="/Elementaires" element={<Elementaires />} />
        <Route path="/Liste-types-vehicules" element={<ListeTypesVehicules />} />
        {/* <Route path="/Liste-assureurs" element={<ListeAssureurs />} /> */}
        {/* <Route path="/Liste-frets" element={<ListeFrets />} /> */}
        <Route path="/Pieces-admin" element={<ListePiecesAdmin />} />
        <Route path="/Liste-parametre" element={<Parametrage />} />
        <Route path="/Gestion-des-tours-national" element={<Gestion_des_tours_national />} />
        <Route path="/ecrans/:parc_ref/Liste-nationaux" element={<Liste_nationaux />} />
        <Route path="/ecrans/:parc_ref/Liste-pays-destination" element={<Liste_pays_destination />} />
        {/* <Route path="/Liste-bailleurs-fret" element={<Liste_bailleurs_fret />} /> */}
        {/* <Route path="/Liste-bailleurs" element={<Liste_bailleurs />} /> */}
        <Route path="/Liste-declaration-fret" element={<Liste_declaration_fret />} />
        {/* <Route path="/Enregistrer-fret" element={<Enregistrer_fret />} /> */}
        {/* <Route path="/Modifier-fret" element={<Modifier_fret />} /> */}
        {/* <Route path="/Liste-conducteur" element={<ListeConducteurs />} /> */}
        <Route path="/Enrolement-archives" element={<Enrolement_archives />} />
        <Route path="/Liste-journalisation" element={<Journalisation />} />
        <Route path="/Corbeilles" element={<Corbeilles />} />
        <Route path="/Liste-fret-corbeille" element={<Liste_fret_corbeille />} />
        <Route path="/Liste-parc" element={<ListeParcs />} />
        {/* <Route path="/Liste-nature" element={<ListeNatures />} /> */}
        <Route path="/Gestion-des-tours-international" element={<Gestion_des_tours_international />} />       
        <Route path="/Gestion-des-tours" element={<Gestion_des_tours />} />       
        {/* <Route path="/Modifier-vehicule_admin" element={<Modifier_vehicule_admin />} />    */}
        <Route path="/Reinitialiser-password/:token" element={<ResetPassword />} />       
        <Route path="/Manuel-utilisation" element={<ManuelUtilisation />} />         
        <Route path="/Manuel-utilisation-admin" element={<ManuelUtilisationAdmin />} />  
        <Route path="/ecrans/:parc_ref/liste-frets-ecran/" element={<Liste_frets_ecran />} />      
        <Route path="/Rapport-et-statistique/" element={<Rapport_et_statistique />} /> 
        <Route path="/Liste-organisations/" element={<ListeOrganisations />} />      
        <Route path="/Liste-essieux/" element={<ListeEssieux />} />      
        <Route path="/Historique-des-paiements/" element={<Historique_paiement />} />      
        <Route path="/Liste-categories/" element={<ListeCategorie />} />      
        <Route path="/Ecrans" element={<Liste_des_parcs />} />      
        <Route path="/Parcs" element={<Gestion_des_tours_parc />} />

        <Route path="/Parcs-GIE" element={<Gie_parcs />} />      
        <Route path="/Factures-GIE" element={<Factures />} />      

        <Route path="/Parc-tampon" element={<ListeParcTampon />} />  


        <Route path="/dashboard" element={<Dashboard />} />      
      </Routes>
    </Router>
  );
}

export default App;